import { render } from "./ShopTerm.vue?vue&type=template&id=390c59e8"
import script from "./ShopTerm.vue?vue&type=script&lang=js"
export * from "./ShopTerm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__